import React from "react";
import ReactSelect from "react-select";

export const PriceSelector = ({
  pricingItems,
  selectedCountry,
  updatePriceCallback
}) => {
  if (!selectedCountry) return null;

  return (
    <div className="priceselector">
      <div className="priceselector__selector">
        <ReactSelect
          name="country"
          multi={false}
          value={selectedCountry.value}
          placeholder="Select country"
          options={pricingItems}
          onChange={updatePriceCallback}
        />
      </div>
      <ul className="priceselector__prices">
        {selectedCountry.pricing.landline && (
          <li className="priceselector__prices__item u-type--negative">
            <span className="priceselector__prices__item__title u-type--eta u-type--o50 u-type--upper">
              Landline:
            </span>{" "}
            <span className="priceselector__prices__item__price u-type--delta u-type--serif">
              $ {selectedCountry.pricing.landline}
            </span>
          </li>
        )}
        {selectedCountry.pricing.mobile && (
          <li className="priceselector__prices__item u-type--negative">
            <span className="priceselector__prices__item__title u-type--eta u-type--o50 u-type--upper">
              Mobile:
            </span>{" "}
            <span className="priceselector__prices__item__price u-type--delta u-type--serif">
              $ {selectedCountry.pricing.mobile}
            </span>
          </li>
        )}
        {selectedCountry.pricing.sms && (
          <li className="priceselector__prices__item u-type--negative">
            <span className="priceselector__prices__item__title u-type--eta u-type--o50 u-type--upper">
              SMS:
            </span>{" "}
            <span className="priceselector__prices__item__price u-type--delta u-type--serif">
              $ {selectedCountry.pricing.sms}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PriceSelector.jsx